import { GetStaticProps, InferGetStaticPropsType } from 'next'
import { Template } from '@/components/common/Template'
import { readFileSync } from 'fs'
import { join } from 'path'
import { css } from '@emotion/react'
import { colors, mq } from 'plume-ui'
import { TouMarkdown } from '@/components/pages/tou/TouMarkdown'
import { DefaultHead } from '@/components/common/Head'

type MarkdownProps = {
  value: string
}

export const getStaticProps: GetStaticProps<{
  markdown: MarkdownProps
}> = async () => {
  const markdownPath = join(
    process.cwd(),
    'public',
    'static',
    'tou',
    'guest.md'
  )
  const markdownText = readFileSync(markdownPath, 'utf8')
  return { props: { markdown: { value: markdownText } } }
}

function GuestTouPage({
  markdown,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <Template>
      <DefaultHead title="利用規約 - スピーダ スタートアップ情報リサーチ" />
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 40px 40px 24px;
          background: ${colors.gray30};
          height: 200px;
          ${mq.untilMedium} {
            height: 128px;
            padding: 24px 24px 16px;
          }
        `}
      >
        <div>
          <h1
            css={css`
              font-size: 42px;
              text-align: center;
              line-height: 1.5;
              margin: 0 0 8px 0;
              letter-spacing: 0.01em;
              ${mq.untilMedium} {
                font-size: 24px;
              }
            `}
            data-testid="tou-title"
          >
            利用規約
          </h1>
        </div>
      </div>
      <div
        css={css`
          display: flex;
          justify-content: center;
        `}
      >
        <div
          css={css`
            padding: 64px 0 40px 0;
            max-width: 928px;
            ${mq.untilMedium} {
              padding: 40px 24px;
            }
          `}
        >
          <TouMarkdown>{markdown.value}</TouMarkdown>
        </div>
      </div>
    </Template>
  )
}

export default GuestTouPage
